import { render, staticRenderFns } from "./SlideButtons.vue?vue&type=template&id=1e0c7c1e&scoped=true&"
import script from "./SlideButtons.vue?vue&type=script&lang=ts&"
export * from "./SlideButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SlideButtons.vue?vue&type=style&index=0&id=1e0c7c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0c7c1e",
  null
  
)

export default component.exports